import React, { useEffect, useState } from 'react';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';
import axios from '../../util/Api';
import { message, Collapse, Row, Col, Button } from 'antd';

const Faq = () => {
  const [loading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState([]);

  const [loadingContact, setLoadingContact] = useState(true);
  const [contact, setContact] = useState({});

  useEffect(() => {
    setLoading(true);
    const url = `/faq/list`;
    axios.get(url).then(resp => {
      setFaqs(resp.data.faq);
      setLoading(false);
    }).catch(err => {
      message.error("Gagal memuat data FAQ");
    });
  }, []);

  useEffect(() => {
    setLoadingContact(true);
    const url = `/faq/contact`;
    axios.get(url).then(resp => {
      setContact(resp.data);
      setLoadingContact(false);
    }).catch(err => {
      message.error("Gagal memuat data contact");
    });
  }, []);

  const Content = () => {
    return (
      <Collapse accordion>
        {faqs.map((item, key) => {
          return (
            <Collapse.Panel header={item.title} key={item.id}>
              <div dangerouslySetInnerHTML={{__html: item.content}}></div>
            </Collapse.Panel>
          );
        })}
      </Collapse>
    )
  }

  const adminChat = () => {
    const whatsappUrl = `https://wa.me/${contact.number}?text="Halo admin ${contact.name} saya mau bertanya perihal QHSE Passport"`;
    window.open(whatsappUrl, '_blank');
  }
  return (
    <Auxiliary>
      <Row>
        <Col md={12}>
          <Title>FAQ</Title>
        </Col>
        <Col md={12}>
          {loading ? null : (
            <div className="gx-text-right">
              <Button type="primary" onClick={adminChat}>Chat dengan Admin</Button>
            </div>
          )}
        </Col>
      </Row>
      {loading ? "Sedang memuat..." : <Content />}
    </Auxiliary>
  );
}

export default Faq;